import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Switch from "react-switch";
import FilterSection from "../../../vendorDashboardComponents/events/OfflineEventDetails/FilterSection";
// import OfflineEventDetailsMain from "../../../vendorDashboardComponents/events/OfflineEventDetails/OfflineEventTable/OfflineEventDetailsMain";
import AboveFilterDesc from "../../../vendorDashboardComponents/events/OfflineEventDetails/TopMenu";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../../vendorDashboardComponents/navigationSection/RightSideNavigation";
import OfflineEventDetailsScreen from "../superAdminRestaurantEvents/OfflineEventDetails/OfflineEventDetails";

class SuperAdminOfflineEventDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathname: this.props.location.pathname,
    };
  }
  render() {
    const { pathname } = this.state;
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText={pathname.includes("superadmin") && "vendorReview"}
              />
              <div className="container-fluid seating_dashboard_top_new_header">
                <div className="row">
                  <div className="col-5">
                    <h4>Event Dashboard</h4>
                  </div>
                  <div className="col-4 text-right f14-500">
                    <div className="d-flex align-items-center py-4 pl-md-4">
                      <div className="f16-500 mr-2">
                        Auto Accept: RSVP &nbsp; No
                      </div>
                      <Switch
                        // onChange={handleChangeSwitch}
                        checked={false}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={24}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={15}
                        width={41}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                        // disabled={disabled === true ? true : false}
                      />
                      <div className="f16-500 ml-2">Yes</div>
                    </div>
                  </div>

                  <div className="col-3 text-right">
                    <NavLink
                      to="/offline-events/add-event"
                      className="btn btn-danger btn-lg"
                    >
                      + Add Guest
                    </NavLink>
                  </div>
                </div>
                <span style={{ fontWeight: "bold" }}>
                  Sonali Wedding Event{" "}
                </span>
                <span
                  className="badge badge-warning"
                  style={{ padding: "5px 15px" }}
                >
                  Offline
                </span>
                <br />
                <span style={{ color: "#EE3A23" }}>Event ID: 123434343</span>
              </div>
              <AboveFilterDesc pathname={pathname} />
              <FilterSection pathname={pathname} />
              <div>
                <OfflineEventDetailsScreen pathname={pathname} />
              </div>
            </div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default SuperAdminOfflineEventDetails;
